import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { FILE_TYPE_ALIASES, PDF_TYPE } from '../../../constants/file'
import { QA_NAME_ATTACH_BTN } from '../../../constants/qa'
import ButtonComponent from '../../Button'
import { FILE_UPLOAD_DROPZONE_OPTIONS, FileUpload } from '../../File'
import { DOC_FLOW_MAX_FILES_NUMBER } from '../DocFlow.constants'

import { isDocFlowMaxFilesReached } from './DocFlowAttachFilesButton.utils'

import AttachIcon from '../../../icons/attach.svg'

function DocFlowAttachFilesButton({
  Button = ButtonComponent.Outlined,
  disabled,
  text = 'DocumentStapling.ProfileAttachBtnKey',
  totalFilesCount,
  onFinishUpload,
  onStartUpload,
  onUploadErrors,
}) {
  const { t } = useTranslation()

  const isMaxFiles = isDocFlowMaxFilesReached(totalFilesCount)

  const isDisabledButton = disabled || isMaxFiles

  return (
    <FileUpload
      options={{
        ...FILE_UPLOAD_DROPZONE_OPTIONS,
        accept: {
          [FILE_TYPE_ALIASES[PDF_TYPE]]: [`.${PDF_TYPE}`],
        },
        disabled: isDisabledButton,
        maxFiles: DOC_FLOW_MAX_FILES_NUMBER,
      }}
      uploadedFilesLength={totalFilesCount}
      onFinishUpload={onFinishUpload}
      onStartUpload={onStartUpload}
      onUploadErrors={onUploadErrors}
    >
      <Button
        beforeIconProps={{ Icon: AttachIcon }}
        disabled={isDisabledButton}
        qaName={QA_NAME_ATTACH_BTN}
        text={t(text)}
        tooltip={
          isMaxFiles
            ? t('Common.FileMaxNumberErrorKey', {
                count: DOC_FLOW_MAX_FILES_NUMBER,
              })
            : null
        }
        tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
        type='button'
      />
    </FileUpload>
  )
}

export default DocFlowAttachFilesButton
